module.exports = __webpack_public_path__ + "img/Boy_020025.3a0f4a27.png";